/**
 * Common mui datatables options.
 */
export default {
  filterType: "textField",
  print: false,
  viewColumns: false,
  selectableRowsOnClick: true,
  setTableProps: () => ({
    padding: "default",
    size: "small"
  })
}
